/**
 * Compose conditional className strings without a dependency.
 * Accepts strings, undefined, false, null, or [string, boolean] pairs.
 *
 *   cx('foo', cond && 'bar', { baz: isBaz })  // not supported (kept tiny)
 *   cx('foo', cond && 'bar', cond2 ? 'baz' : undefined)
 */
type ClassValue = string | false | null | undefined;

export function cx(...values: ClassValue[]): string {
  return values.filter(Boolean).join(' ');
}
